import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=4acb6b8f&scoped=true&"
import script from "@/views/Subjects/Messages.ts?vue&type=script&lang=ts&"
export * from "@/views/Subjects/Messages.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Subjects/messages.scss?vue&type=style&index=0&id=4acb6b8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb6b8f",
  null
  
)

export default component.exports